/* Shared, fresh public data for title stars and review list. No Admin API token. */
(function (root) {
  'use strict';
  function validate(data, productId) {
    if (!data || data.product_id !== String(productId) || !Array.isArray(data.reviews)) throw new Error('Wrong review product');
    if (data.reviews.some(r => !r || !Number.isInteger(r.rating) || r.rating < 1 || r.rating > 5 ||
      ['id', 'title', 'body', 'author', 'date', 'reply'].some(k => typeof r[k] !== 'string') ||
      !/^\d{4}-\d{2}-\d{2}$/.test(r.date) || !Array.isArray(r.images))) throw new Error('Invalid review record');
    if (new Set(data.reviews.map(r => r.id)).size !== data.reviews.length) throw new Error('Duplicate reviews');
    return data;
  }
  async function collect(path, productId, fetcher, origin) {
    const url = new URL(path, origin);
    if (url.origin !== origin || !/\/products\/[^/]+$/.test(url.pathname)) throw new Error('Invalid review URL');
    url.searchParams.set('view', 'nextbottle-review-data');
    url.searchParams.delete('page');
    const rows = [];
    let pages;
    for (let page = 1; ; page++) {
      url.searchParams.set('page', String(page));
      const response = await fetcher(url.href, {credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) throw new Error('Review request failed');
      const data = validate(await response.json(), productId);
      if (data.page !== page || !Number.isInteger(data.pages) || data.pages < 1 || data.pages > 100 ||
          (pages !== undefined && pages !== data.pages)) throw new Error('Incomplete review pagination');
      pages = data.pages;
      rows.push(...data.reviews);
      if (page === pages) break;
    }
    const data = validate({product_id: String(productId), reviews: rows}, productId);
    data.count = rows.length;
    data.average = rows.length ? rows.reduce((sum, r) => sum + r.rating, 0) / rows.length : null;
    return data;
  }
  function withRating(schema, data) {
    if (!schema || !['Product', 'ProductGroup'].includes(schema['@type'])) return schema;
    const result = {...schema};
    delete result.aggregateRating;
    if (data.count > 0) result.aggregateRating = {
      '@type': 'AggregateRating', ratingValue: Number(data.average.toFixed(4)),
      reviewCount: data.count, bestRating: 5, worstRating: 1
    };
    return result;
  }
  function updateSchema(data) {
    document.querySelectorAll('script[data-nextbottle-product-schema][data-native-review-product]').forEach(script => {
      if (script.dataset.nativeReviewProduct !== data.product_id) return;
      try { script.textContent = JSON.stringify(withRating(JSON.parse(script.textContent), data)).replace(/</g, '\\u003c'); }
      catch { /* Preserve the original Shopify schema if it cannot be parsed. */ }
    });
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {collect, validate, withRating}; return; }
  if (root.NextBottleReviews) return;
  const requests = new Map();
  root.NextBottleReviews = {validate, load(path, id) {
    const key = path + ':' + id;
    if (!requests.has(key)) requests.set(key, collect(path, id, root.fetch.bind(root), root.location.origin).then(data => { updateSchema(data); return data; }).catch(error => { requests.delete(key); throw error; }));
    return requests.get(key);
  }};
  class ReviewBadge extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.textContent = 'Bewertungen werden geladen …'; this.setAttribute('aria-label', 'Bewertungen werden geladen …');
      try {
        const data = await root.NextBottleReviews.load(this.dataset.source, this.dataset.productId);
        if (!this.isConnected) return;
        this.replaceChildren();
        if (!data.count) { this.textContent = 'Noch keine Bewertungen'; this.setAttribute('aria-label', 'Noch keine Bewertungen'); return; }
        const average = data.average.toLocaleString('de-DE', {maximumFractionDigits: 2});
        this.setAttribute('aria-label', `${average} von 5 Sternen, ${data.count} ${data.count === 1 ? 'Bewertung' : 'Bewertungen'}`);
        const stars = document.createElement('span');
        stars.setAttribute('aria-hidden', 'true');
        stars.style.cssText = 'position:relative;display:inline-block;white-space:nowrap;color:#d8ccb0;letter-spacing:2px;font-size:27px;line-height:1.2';
        stars.textContent = '☆☆☆☆☆';
        const fill = document.createElement('span');
        fill.textContent = '★★★★★';
        fill.style.cssText = `position:absolute;left:0;top:0;overflow:hidden;color:#866000;width:${data.average * 20}%`;
        stars.append(fill);
        const text = document.createElement('span');
        text.style.cssText = 'display:flex;flex-direction:column;gap:1px;line-height:1.35';
        const score = document.createElement('span');
        score.textContent = `Ø ${average}/5`;
        score.style.cssText = 'font-size:16px;color:#52656c';
        const total = document.createElement('strong');
        total.textContent = `${data.count} ${data.count === 1 ? 'Bewertung' : 'Bewertungen'}`;
        total.style.cssText = 'font-size:15px;color:#172c33';
        text.append(score, total);
        this.style.cssText = 'display:inline-flex;align-items:center;gap:14px;margin:12px 0;padding:10px 0;background:transparent';
        text.setAttribute('aria-hidden', 'true');
        this.append(stars, text);
      } catch { this.textContent = 'Bewertungen derzeit nicht verfügbar'; this.setAttribute('aria-label', 'Bewertungen derzeit nicht verfügbar'); }
    }
  }
  customElements.define('nb-review-badge', ReviewBadge);
})(typeof window === 'undefined' ? null : window);
